import { useFormik } from "formik";
import React, { useContext, useEffect, useRef, useState } from "react";
import edit from "../assets/images/icons/edit.png";
import PageHeader from "../Components/PageHeader";
import Table from "../Components/Table";
import TableContent from "../Components/TableContent";
import TableHeader from "../Components/TableHeader";
import * as Yup from "yup";
import InputField from "../Components/InputField";
import request, { URL } from "../services/request";
import endPoint from "../services/endPoint";
import { AppContext } from "../services/context";
import Notify from "../Components/Notify";
import tag from "../assets/images/tag.png";
import shopping from "../assets/images/shopping.png";
import group from "../assets/images/group.png";
import { toast } from "react-toastify";

const initData = {
  "titre": "",
  "description": "",
  "media": "",
  "type": "",
  "emplacement": "home",
  "date_debut": "",
  "date_fin": ""
};
const Publicite = () => {
  const authCtx = useContext(AppContext);
  const { user } = authCtx;
  const [datas, setDatas] = useState([]);
  const [editId, setEditId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [viewData, setViewData] = useState({});
  const modal = useRef();
  const types = [
    { value: "image", label: "Image" },
    { value: "video", label: "Vidéo" },
    //{ value: "text", label: "Text" },
  ];
  const header = {
    headers: {
      Authorization: `Bearer ${user.token}`,
      "Content-Type": "multipart/form-data",
    },
  };

  useEffect(() => {
    getAll();
  }, [refresh]);
  const validateData = Yup.object({
    titre: Yup.string()
      .min(3, "Le nom de la marque doit contenir 3 caractères ou moins")
      .required("Ce champ est obligatoire. Veuillez le remplir pour continuer"),
    date_debut: Yup.string()
      .required("Ce champ est obligatoire. Veuillez le remplir pour continuer"),
    date_fin: Yup.string()
      .required("Ce champ est obligatoire. Veuillez le remplir pour continuer"),
    type: Yup.object()
      .required("Ce champ est obligatoire. Veuillez le remplir pour continuer"),
    /*media: Yup.mixed()
      .required("Un fichier est requis")
      .test(
        "fileFormat",
        "Seuls les fichiers jpeg, png et gif sont autorisés",
        (value) => {
          return (
            value &&
            ["image/jpeg", "image/png", "image/gif"].includes(value.type)
          );
        }
      )
      .test("fileSize", "La taille maximale autorisée est de 2 Mo", (value) => {
        return value && value.size <= 2 * 1024 * 1024;
      }),*/
    description: Yup.string()
      .min(3, "La description doit contenir 3 caractères ou moins")
      .required("Ce champ est obligatoire. Veuillez le remplir pour continuer"),
    /*image: Yup.mixed()
      .required("Une image est requise")
      .test(
        "fileFormat",
        "Seuls les fichiers jpeg, png et gif sont autorisés",
        (value) => {
          return (
            value &&
            ["image/jpeg", "image/png", "image/gif"].includes(value.type)
          );
        }
      )
      .test("fileSize", "La taille maximale autorisée est de 2 Mo", (value) => {
        return value && value.size <= 2 * 1024 * 1024;
      }),*/
  });
  const formik = useFormik({
    initialValues: initData,
    validationSchema: validateData,
    onSubmit: (values) => {
      console.log(values);
      values.type = values.type.value;
      values.emplacement = "home";
      if (editId === "") {
        handleSubmit(values);
      } else {
        values._method = "put";
        handleEditSubmit(values);
      }
    },
  });

  const getAll = () => {
    request
      .get(endPoint.publicites, header)
      .then((res) => {
        setDatas(res.data.data);
        console.log(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleSubmit = (values) => {
    toast.promise(request.post(endPoint.publicites, values, header), {
      pending: "Veuillez patienté...",
      success: {
        render({ data }) {
          console.log(data);
          const res = data;
          modal.current.click();
          getAll();

          return res.data.message;
        },
      },
      error: {
        render({ data }) {
          console.log(data);
          if (data?.response?.data?.message) {
            return data?.response?.data?.message;
          }
          return data?.response?.data?.errors
            ? data?.response?.data?.errors
            : data?.response?.data?.error;
        },
      },
    });
  };
  const handleEditSubmit = (values) => {
    //setShowModal(true)
    console.log(values);
    toast.promise(
      request.post(endPoint.publicites + "/" + editId, values, header),
      {
        pending: "Veuillez patienté...",
        success: {
          render({ data }) {
            console.log(data);
            const res = data;
            modal.current.click();
            getAll();

            return res.data.message;
          },
        },
        error: {
          render({ data }) {
            console.log(data);
            if (data?.response?.data?.message) {
              return data?.response?.data?.message;
            }
            return data?.response?.data?.errors
              ? data?.response?.data?.errors
              : data?.response?.data?.error;
          },
        },
      }
    );
  };

  const onDelete = () => {
    toast.promise(
      request.delete(endPoint.publicites + "/" + viewData.slug, header),
      {
        pending: "Veuillez patienté...",
        success: {
          render({ data }) {
            console.log(data);
            const res = data;

            getAll();

            return res.data.message;
          },
        },
        error: {
          render({ data }) {
            console.log(data);
            if (data?.response?.data?.message) {
              return data?.response?.data?.message;
            }
            return data?.response?.data?.errors
              ? data?.response?.data?.errors
              : data?.response?.data?.error;
          },
        },
      }
    );
  };

  const setDataToEdit = (e, data) => {
    e.preventDefault();
    console.log(new Date(data.date_debut).toISOString().split("T")[0]);
    formik.setFieldValue("titre", data.titre);
    formik.setFieldValue("date_debut", new Date(data.date_debut).toISOString().split("T")[0]);
    formik.setFieldValue("date_fin", new Date(data.date_fin).toISOString().split("T")[0]);
    formik.setFieldValue("type", types.find((item) => item.value === data.type));
    formik.setFieldValue("description", data.description);
    setEditId(data.slug);
  }

  const addModal = (e) => {
    e.preventDefault();
    setEditId("");
    formik.resetForm();
  };
  return (
    <>
      {/**
       * <div className="row">
        <div className="col-12">
          <div className="row row-cols-1 row-cols-sm-4">
            {[
              { name: "Marques", img: tag },
              { name: "Models", img: tag },
              { name: "Années", img: tag },
            ].map((data, idx) => {
              return (
                <div className="col mb-3" key={idx}>
                  <div className="card btn-primary-light p-4">
                    <div className="d-flex align-items-center">
                      <div className="text-center">
                        <h6 className="text-16 fw-bold fs-4">{data.name}</h6>
                      </div>
                      <div className="ms-auto">
                        <img width="40px" src={data.img} alt="" />
                      </div>
                    </div>
                    <div>
                      <span>145</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
       */}
      <PageHeader title="Liste des publicités" modal="form" addModal={addModal} />
      <Table>
        <TableHeader>
          <th scope="col" className="border-raduis-left">
            #
          </th>
          <th scope="col">Image</th>
          <th scope="col">Titre</th>
          <th scope="col">Début - Fin</th>
          <th scope="col">Type</th>
          <th scope="col">Etat</th>
          <th scope="col">Description</th>
          <th scope="col" className="text-center">
            Actions
          </th>
        </TableHeader>
        <TableContent>
          {datas.map((data, idx) => {
            return (
              <tr key={idx}>
                <td>
                  <input type="checkbox" value="selected" />
                </td>
                <td className="fw-bold">
                  {data.type === "image" ? <img width="50px" height="auto" src={URL + data.media} alt="" /> : <video width="50px" height="auto" >
                    <track kind="captions" srcLang="en" label="English captions" />
                    <source src={URL + data.media} type="video/mp4" />Your browser does not support the video tag.
                  </video>
                  }
                </td>
                <td className="fw-bold">{data.titre}</td>
                <td className="fw-bold">{new Date(data.date_debut).toLocaleDateString() + " - " + new Date(data.date_fin).toLocaleDateString()}</td>
                <td className="fw-bold">{data.type}</td>
                <td className="fw-bold">{data.actif === 1 ? <>
                  <span className="badge bg-success">Actif</span>
                </> : <span className="badge bg-danger">Inactif</span>}</td>
                <td className="fw-bold">{data.description}</td>
                <td className="text-center">
                  <div className="btn-group">
                    <div className="d-inline-block mx-1">
                      <button
                        className="btn btn-primary-light"
                        data-bs-toggle="modal"
                        data-bs-target="#view"
                        onClick={(e) => {
                          setViewData(data);
                        }}
                      >
                        <span>
                          {" "}
                          <i className="bi bi-eye-fill"></i>
                        </span>
                      </button>
                    </div>
                    <div className="d-inline-block mx-1">
                      <button
                        className="btn btn-primary-light"
                        data-bs-toggle="modal"
                        data-bs-target="#form"
                        onClick={e => setDataToEdit(e, data)}
                      >
                        <span>
                          {" "}
                          <i className="bi bi-pencil-square"></i>
                        </span>
                      </button>
                    </div>
                    <div className="d-inline-block mx-1">
                      <button
                        className="btn btn-danger"
                        data-bs-toggle="modal"
                        data-bs-target="#delete"
                        onClick={(e) => {
                          setViewData(data);
                        }}
                      >
                        <span>
                          <i className="bi bi-trash3-fill"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            );
          })}
        </TableContent>
      </Table>
      <div className="modal fade" id="form">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h4 className="modal-title text-meduim text-bold">
                {editId !== ""
                  ? "Modification d’une marque"
                  : "Ajout d’une marque"}
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <form onSubmit={formik.handleSubmit}>
                <InputField
                  type={"text"}
                  name="titre"
                  formik={formik}
                  placeholder="Titre de la publicité"
                  label={"Titre"}
                />

                <InputField
                  type={"date"}
                  name="date_debut"
                  formik={formik}
                  placeholder=""
                  label={"Date de début"}
                />

                <InputField
                  type={"date"}
                  name="date_fin"
                  formik={formik}
                  placeholder=""
                  label={"Date de fin"}
                />

                <InputField
                  type={"react-select"}
                  name="type"
                  formik={formik}
                  placeholder="Sélectionnez le type de publicité"
                  label={"Type de publicité"}
                  options={types}
                />


                <InputField
                  type={"file"}
                  name="media"
                  formik={formik}
                  placeholder="Choisir un fichier"
                  label={"Fichier image ou vidéo"}
                />

                <InputField
                  type={"textaera"}
                  name="description"
                  formik={formik}
                  placeholder="Description de la marque"
                  label={"Description"}
                />

                <div className="d-flex justify-content-start border-0">
                  <button
                    type="reset"
                    className="btn btn-primary-light me-2"
                    data-bs-dismiss="modal"
                    ref={modal}
                  >
                    Annuler
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Enregistrer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h4 className="modal-title text-meduim text-bold">Suppression</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <div>Voulez-vous supprimer définitivement les données ?</div>
              <div className="mt-4 d-flex justify-content-end">
                <button
                  className="btn btn-primary me-2"
                  data-bs-dismiss="modal"
                >
                  Non
                </button>
                <button
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={onDelete}
                >
                  Oui
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="view">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h4 className="modal-title text-meduim text-bold">
                Informations
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body text-center1">
              <div className="mb-3">
                {
                  viewData.type === "image" ? <img width="100%" height="auto" src={URL + viewData.media} alt="" /> : <video width="100%" height="auto" controls>
                    <source src={URL + viewData.media} type="video/mp4" />
                    Your browser does not support the video tag.</video>
                }
              </div>
              <div>
                <span className="fw-bold d-inline-block me-2">Titre : </span>
                <span className="d-inline-block">{viewData.titre}</span>
              </div>
              <div>
                <span className="fw-bold d-inline-block me-2">Type : </span>
                <span className="d-inline-block">{viewData.type}</span>
              </div>
              <div>
                <span className="fw-bold d-inline-block me-2">Date de début : </span>
                <span className="d-inline-block">{new Date(viewData.date_debut).toLocaleDateString()}</span>
              </div>
              <div>
                <span className="fw-bold d-inline-block me-2">Date de fin : </span>
                <span className="d-inline-block">{new Date(viewData.date_fin).toLocaleDateString()}</span>
              </div>
              <div>
                <span className="fw-bold d-inline-block me-2">Emplacement : </span>
                <span className="d-inline-block">{viewData.emplacement}</span>
              </div>
              <div>
                <span className="fw-bold d-inline-block me-2">Etat : </span>
                <span className="d-inline-block">{viewData.actif === 1 ? <>
                  <span className="badge bg-success">Actif</span>
                </> : <span className="badge bg-danger">Inactif</span>}</span>
              </div>
              <div>
                <span className="fw-bold d-inline-block me-2">
                  Description :{" "}
                </span>
                <span className="d-inline-block">{viewData.description}</span>
              </div>
              <div className="mt-4 d-flex justify-content-end">
                <button className="btn btn-primary" data-bs-dismiss="modal">
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Notify showModal={showModal} />
    </>
  );
};

export default Publicite;
